import React, { useEffect, useState } from "react";
import SchedulerTest from "../components/SchedulerTest";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Contacts from "../components/Contacts";
import AppShell from "../components/AppShell";
import MobileHeader from "../components/MobileHeader";
import CalendarWeekNav from "../components/CalendarWeekNav";
import CalendarMonthPopup from "../components/CalendarMonthPopup";
import "../components/scheduler.css";

const CalendarTest = () => {
  const [isDrawOpen, setIsDrawOpen] = useState(false);
  const [showMonthPopup, setShowMonthPopup] = useState(false);

  const [formattedStart, setFormatedStart] = useState(
    moment().startOf("week").format("DD")
  );
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [formattedEnd, setFormatedEnd] = useState(
    moment().endOf("week").format("DD")
  );

  const [formattedMonth, setFormatedMonth] = useState(
    moment().startOf("week").format("MMMM")
  );
  const handleNavigate = (direction) => {
    let newDate;
    if (direction === "next") {
      console.log("nesto");
      newDate = moment(selectedDate).add(1, "week").toDate();

      const startOfWeek = moment(newDate).startOf("week").format("DD");
      const endOfWeek = moment(newDate).endOf("week").format("DD");
      setFormatedStart(startOfWeek);
      setFormatedEnd(endOfWeek);
    } else if (direction === "prev") {
      newDate = moment(selectedDate).subtract(1, "week").toDate();

      const startOfWeek = moment(newDate).startOf("week").format("DD");
      const endOfWeek = moment(newDate).endOf("week").format("DD");
      setFormatedStart(startOfWeek);
      setFormatedEnd(endOfWeek);
    } else if (direction === "today") {
      newDate = new Date();

      const startOfWeek = moment(newDate).startOf("week").format("DD");
      const endOfWeek = moment(newDate).endOf("week").format("DD");
      setFormatedStart(startOfWeek);
      setFormatedEnd(endOfWeek);
    }
    setSelectedDate(newDate);
  };

  // Jumping to an arbitrary date from the Mobile "jump to month" popup — same week-range
  // recompute handleNavigate already does for prev/next/today, just for a date picked directly
  // instead of stepping by one week. Reuses the same setSelectedDate the rest of the screen
  // already reacts to, so the week grid/agenda/today-styling all sync automatically.
  const handleDateSelect = (date) => {
    const startOfWeek = moment(date).startOf("week").format("DD");
    const endOfWeek = moment(date).endOf("week").format("DD");
    setFormatedStart(startOfWeek);
    setFormatedEnd(endOfWeek);
    setSelectedDate(date);
  };

  // Compact "24.08. - 29.08.'26" form for the fixed Mobile header, between the hamburger and
  // bell — replaces the old plain "Kalendar" title there. Built directly from `selectedDate`
  // rather than reusing SchedulerTest's own `weekRangeLabel` (a longer "24 avg – 29 avg 2026"
  // form meant for the in-page nav row this is replacing), since that's local state inside
  // SchedulerTest and this lives one level up.
  const mobileWeekStart = moment(selectedDate).startOf("week");
  const mobileWeekEnd = moment(selectedDate).endOf("week");
  const mobileWeekLabel = `${mobileWeekStart.format(
    "DD.MM."
  )} - ${mobileWeekEnd.format("DD.MM.")}'${mobileWeekEnd.format("YY")}`;

  return (
    <AppShell active="calendar">
      <MobileHeader
        title={
          <CalendarWeekNav
            variant="mobile"
            label={mobileWeekLabel}
            onPrev={() => handleNavigate("prev")}
            onNext={() => handleNavigate("next")}
            onToday={() => handleNavigate("today")}
          />
        }
      />
      {showMonthPopup && (
        <CalendarMonthPopup
          selectedDate={selectedDate}
          onSelectDate={handleDateSelect}
          onClose={() => setShowMonthPopup(false)}
        />
      )}
      <div className="main-container hf-cal-page">
        {/* <Contacts /> */}
        <div className="calendar-main-container selection">
          <div className="fake-container"></div>
          <div className="calendar-container-2">
            <SchedulerTest
              handleNavigate={handleNavigate}
              selectedDate={selectedDate}
            />
          </div>
        </div>
      </div>
    </AppShell>
  );
};

export default CalendarTest;
